import { mode } from "@chakra-ui/theme-tools";
import { StyleFunctionProps } from "@chakra-ui/react";

interface CardStyleObject {
  p: string;
  display: string;
  flexDirection: string;
  width: string;
  position: string;
  borderRadius: string;
  minWidth: string;
  wordWrap: string;
  bg: string;
  backgroundClip: string;
}

interface CardConfig {
  baseStyle: (props: StyleFunctionProps) => CardStyleObject;
}

interface CardComponentConfig {
  components: {
    Card: CardConfig;
  };
}

const Card: CardConfig = {
  baseStyle: (props: StyleFunctionProps) => ({
    p: "20px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: "20px",
    minWidth: "0px",
    wordWrap: "break-word",
    bg: mode("#ffffff", "navy.800")(props),
    backgroundClip: "border-box",
  }),
};

export const CardComponent: CardComponentConfig = {
  components: {
    Card,
  },
};
